import { render, staticRenderFns } from "./GrabBag.vue?vue&type=template&id=c785f278"
import script from "./GrabBag.vue?vue&type=script&lang=ts"
export * from "./GrabBag.vue?vue&type=script&lang=ts"
import style0 from "./GrabBag.vue?vue&type=style&index=0&id=c785f278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports